module.exports = __webpack_public_path__ + "img/horny_mushroom.f348d478.png";